import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useParams} from 'react-router-dom'
import {usePage} from '@salesforce/commerce-sdk-react'
import PDCBreadcrumb from '../../../components/pdc-breadcrumb/index.jsx'

import {getEnvStaleTime} from '../../../utils/utils.js'
import PropTypes from 'prop-types'

/**
 * PDCSubmenu is a React functional component that renders a submenu for the Page Designer Canvas (PDC) application.
 * It determines the current page ID from either the provided `currentPageId` prop or the URL parameters, and fetches
 * the corresponding page data using the `usePage` hook with a configurable stale time. The component displays a
 * breadcrumb navigation (`PDCBreadcrumb`) for the current page, ensuring proper structured data for SEO by providing
 * the necessary `homePage` and `homeUrl` props. The submenu is centered both vertically and horizontally using a
 * Flex container.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.currentPageId] - Optional. The ID of the current page to display in the submenu. If not provided, the ID is obtained from the URL parameters.
 * @returns {JSX.Element} A flex container with a breadcrumb navigation for the current page.
 */
export const PDCSubmenu = ({currentPageId}) => {
    const params = useParams()
    const pageId = currentPageId || params.pageId
    const staleTime = getEnvStaleTime()
    const {data: currentPage} = usePage({parameters: {pageId}}, {staleTime: staleTime})

    return (
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
            <PDCBreadcrumb
                currentPage={currentPage}
                homePage={{id: currentPage?.id, name: currentPage?.name}} // required for breadcrumb structured data
                homeUrl={{}} // required for breadcrumb structured data
                isRootPage={true}
            />
        </Flex>
    )
}

PDCSubmenu.propTypes = {
    currentPageId: PropTypes.string
}
